const normalize = (value: number) => {
  return Intl.NumberFormat().format(value);
};

const currency = (value: number) => {
  return Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
};

const format = (value: number, locales?: Intl.LocalesArgument, decimals = 2): string => {
  const formatted = new Intl.NumberFormat(locales, {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  }).format(value);

  return formatted;
};

export const numberFormat = {
  normalize,
  currency,
  format,
};
